<template >
  <div>
    <!-- 面包屑导航 -->
  <div class="flexc-cen-x fixed" >
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>预约情况</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
  </div>
  <div style="height:75vh;padding-top:30px;">
      <el-form :inline="true" :model="formInline"  style="height:40px;">
        <el-form-item :label="WZCDName+':'"  prop="Site" v-if="IsCD == 1">
            <el-select v-model="site" clearable placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in siteList"
                    :key="item.ID"
                    :label="item.SiteName"
                    :value="item.ID">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="WZXMName+'：'" prop="Site" v-if=" projectList.length>1 ">
            <el-select clearable v-model="objID" placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item>
        <el-form-item :label="WZXMName+'类型：'" prop="RowType" v-if="RowTypeList.length>1">
              <el-select clearable v-model="RowType" placeholder="请选择" size="mini">
                      <el-option
                        v-for="item in RowTypeList"
                        :key="item.ID"
                        :label="item.RowTypeName"
                        :value="item.ID">
                      </el-option>
                    </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <!-- <el-button  size="mini" type="primary"    icon="el-icon-plus" @click="handleEdit()">排班</el-button> -->
        </el-form-item>
      </el-form>
      <div class="top flex-spc-x" style="width:100%;height:60px">
         <div class="flexc-cen-x">
            <el-button plain size="small" @click="toToady()">
              <span v-if="type == 1">今日</span>
              <span v-else>本周</span>
            </el-button>
                <el-button size="small" @click="toYesterDay()" style="margin-left:20px" icon="el-icon-arrow-left" circle></el-button>
                <el-button size="small" @click="toTomorrow()" style="margin-left:20px" icon="el-icon-arrow-right" circle></el-button>
                <el-date-picker
                  v-if="type == 1"
                    style="margin-left:20px"
                    v-model="date"
                    type="date"
                    size="small"
                    @change="changeDate()"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <span v-if="type == 1" style="margin-left:10px;font-weight:600">{{dayList[day]}}</span>
          </div>
          <div class="flexc-cen-x">
              <el-radio-group v-model="type" size="small" style="margin-right:40px" @change="changeType()">
                <el-radio-button label="1">日</el-radio-button>
                <el-radio-button label="2">周</el-radio-button>
              </el-radio-group>
            <div class="qie flexc-cen-x cursor" @click="toqiehuan()">
                    <img src="../../assets/img/qie1.png" style="width:20px;height:20px" alt="">
                    <span v-if="chooseTrue">{{WZYGName}}班表</span>
                    <span v-else>{{WZXMName}}班表</span>
            </div>
          </div>
      </div>
      <div class="da" ref="main">
        <div class="main flex-cen-x" v-if="type== 1" >
          <div class="box flex-xy bcss">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
          </div>
          <div class="postMain" style="z-index:9;" ref="systemForm" @scroll="sysHandleScroll()"  @mouseover="changeFlag(true)" >
              <div class="box flex-xy" style="font-weight:600;font-size:16px">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
              </div>
              <div class="box1 flex-xy" v-if="chooseTrue == true"  style="z-index:99"  v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                        <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                        <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                        <div style="margin-left:10px">{{items.Name}}</div>
                  </div>
              </div>
                <div class="box1 flex-xy" v-if="chooseTrue == false" v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                        <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                        <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                        <div style="margin-left:10px">{{items.ProjectName}}</div>
                  </div>
                </div>
          </div>
          <div v-show="cd"   class="maxw posttrue topTime" style="width:99%;z-index:10;background-color:white"  ref="nav">
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list">
                    {{items.startTime}}
                  </div>
          </div>
            <div class="leftMain" style="width:100%" ref='externalForm' @scroll="exterHandleScroll()" @mouseover="changeFlag(true)">
            <div class="maxw posttrue" >
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list1">
                    {{items.startTime}}
                  </div>
            </div>
            <div v-if="chooseTrue == true" class="maxw" v-for="(items,index1) in list">
                    <div class="box1 flex-xy">
                      <div class="flex-spc-x">
                            <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                            <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                            <div style="margin-left:10px">{{items.Name}}</div>
                      </div>
                    </div>
                    <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="(item,index2) in items.ListRowClass">
                        <div class="boxMain " style="height:100%;width:100%">
                          <div class="flex-xy" style="height:85%;width:100%">
                            <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                              <el-popover
                                v-if="it.color && it.isyuyue == 1  && it.YYCount == 0 && it.RowClassTypeqt == 1 "
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                        </div>
                                        <div style="font-size:13px">已预约:<span class="coBlue">{{it.YYCount}}人</span></div>
                                    
                                      </div>
                                      <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-user"></i> 
                                        <span>{{it.terName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                    
                                  </div>
                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                        <div class="qiu" :style="{'background':it.color}">
                                        </div>
                                        <div style="margin-left:10px;color:#d9d9d9">
                                          {{it.ProjectName}}
                                        </div>
                                      </div>
                                    
                                    
                                    </div>
                              </el-popover>
                              <el-popover
                                v-if="it.color && (it.isyuyue != 1 || it.YYCount != 0)"
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                        </div>
                                        <div style="font-size:13px">已预约:<span class="coBlue">{{it.YYCount}}人</span></div>
                                    
                                      </div>
                                      <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-user"></i> 
                                        <span>{{it.terName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%" >
                                          <el-button type="text" @click="toEdit(it)" v-if="q1 == true">预约</el-button>
                                      </div>
                                  </div>
                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                        <div class="qiu" :style="{'background':it.color}">
                                        </div>
                                        <div style="margin-left:10px">
                                          {{it.ProjectName}}
                                        </div>
                                      </div>
                                        <div class="count flex-xy" v-if="it.YYCount !=0">{{it.YYCount}}</div>
                                    </div>
                              </el-popover>
                            </div>
                          </div>
                          <div class="flexc-spc-x">
                            <el-popover
                               v-if="item.ListRowClassSub.length>4"
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%;height:300px; overflow: auto;">
                                      <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                        </div>
                                        <div style="font-size:13px">已预约:<span class="coBlue">{{it.YYCount}}人</span></div>
                                    
                                      </div>
                                        <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-user"></i> 
                                          <span>{{it.terName}}</span>
                                        </div>
                                        <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-location-outline"></i> 
                                          <span>{{it.SiteName}}</span>
                                        </div>
                                        <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                          <i class="el-icon-time"></i> 
                                          <span>{{it.startTime}}</span>
                                        </div>
                                        <div class="flex-r-x" style="width:100%">
                                            <el-button type="text" v-if="q1 == true" @click="toEdit(it)">预约</el-button>
                                          
                                        </div>
                                      </div>
                                    
                                  </div>
                                    <div class="quanbu1 cursor"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                                    
                            </el-popover>
                            <div class="quanbu cursor" v-if="JSON.stringify(item.ListRowClassSub[0]) != '{}' && q1 == true "  style="margin-left:160px" @click="toyue(item,index1,index2)">+预约</div>
                          </div>
                        
                        </div>
                    </div>
                    
            </div>
            <div v-if="chooseTrue == false" class="maxw" v-for="(items,index1) in list">
                    <div class="box1 flex-xy">
                      <div class="flexc-cen-x">
                            <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                            <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                            <div style="margin-left:10px">{{items.ProjectName}}</div>
                      </div>
                    </div>
                    <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="(item,index2) in items.ListRowClass">
                        <div class="boxMain " style="height:100%;width:100%">
                          <div class="flex-xy" style="height:85%;width:100%">
                            <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                              <el-popover
                              v-if="it.terName && it.isyuyue == 1  && it.YYCount == 0 && it.RowClassTypeqt == 1 "
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                          <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                      
                                          <div style="font-size:15px;margin-left:10px;">{{it.terName}}</div>
                                        </div>
                                      
                                            <div style="font-size:13px">已预约:<span class="coBlue">{{it.YYCount}}人</span></div>
                                      </div>
                                      <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-document"></i> 
                                        <span>{{it.ProjectName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div> 
                                  </div>
                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                          <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:20px;height:20px;border-radius:100%">
                                          <img v-else src="../../assets/img/head.png" alt="" style="width:20px;height:20px;border-radius:100%">
                                      <div style="margin-left:10px;color:#d9d9d9">
                                        {{it.terName}}
                                      </div>
                                      </div>
                                    </div>
                                </el-popover>
                              <el-popover
                              v-if="it.terName  && (it.isyuyue != 1 || it.YYCount != 0)"
                    
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                          <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                      
                                          <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                        </div>
                                      
                                            <div style="font-size:13px">已预约:<span class="coBlue">{{it.YYCount}}人</span></div>
                                      </div>
                                      <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-document"></i> 
                                        <span>{{it.ProjectName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q1 == true">预约</el-button>
                                        
                                      </div>
                                  </div>

                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                            <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:20px;height:20px;border-radius:100%">
                                        <img v-else src="../../assets/img/head.png" alt="" style="width:20px;height:20px;border-radius:100%">
                                      <!-- <div class="qiu" :style="{'background':it.color}">
                                      </div> -->
                                      <div style="margin-left:10px">
                                        {{it.terName}}
                                      </div>
                                      </div>
                                  
                                        <div class="count flex-xy" v-if="it.YYCount !=0">{{it.YYCount}}</div>
                                    </div>
                                </el-popover>
                            </div>
                          </div>
        
                        <div class="flexc-spc-x">
                          <el-popover
                            v-if="item.ListRowClassSub.length>4"
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%;height:300px; overflow: auto;">
                                      <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                        <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                          <div class="flexc-cen-x">
                                            <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                            <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                        
                                            <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                          </div>
                                          <div style="font-size:13px">已预约:<span class="coBlue">{{it.YYCount}}人</span></div>
                                        </div>
                                        <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-document"></i> 
                                          <span>{{it.ProjectName}}</span>
                                        </div>
                                        <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-location-outline"></i> 
                                          <span>{{it.SiteName}}</span>
                                        </div>
                                        <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                          <i class="el-icon-time"></i> 
                                          <span>{{it.startTime}}</span>
                                        </div>
                                        <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q1 == true">预约</el-button>
                                          
                                        </div>
                                      </div>
                                    
                                  </div>
                                    <div class="quanbu1 cursor"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                                    
                          </el-popover>
                                
                                  <div class="quanbu cursor" v-if="JSON.stringify(item.ListRowClassSub[0]) != '{}' && q1 == true " style="margin-left:160px" @click="toyue(item,index1,index2)">+预约</div>
                          </div>

                        </div>
                    </div>
                    
              </div>
            </div>
        </div>
      <div class="main flex-cen-x" v-else >
        <div class="box flex-xy bcss">
                  <span v-if="chooseTrue == true">服务人员</span>
                  <span v-else>{{WZXMName}}</span>
        </div>
          <div class="postMain" style="z-index:9;" ref="systemForm" @scroll="sysHandleScroll()"  @mouseover="changeFlag(true)" >
              <div class="box flex-xy" style="font-weight:600;font-size:16px">
                    <span v-if="chooseTrue == true">服务人员</span>
                    <span v-else>{{WZXMName}}</span>
              </div>
              <div class="box1 flex-xy" v-if="chooseTrue == true"  style="z-index:99"  v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                        <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                        <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                        <div style="margin-left:10px">{{items.Name}}</div>
                  </div>
              </div>
                <div class="box1 flex-xy" v-if="chooseTrue == false" v-for="(items,index) in list">
                  <div class="flexc-cen-x" style="width:80%">
                        <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                        <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                        <div style="margin-left:10px">{{items.ProjectName}}</div>
                  </div>
                </div>
          </div>
          <div v-show="cd"   class="maxw posttrue topTime" style="width:99%;z-index:10;background-color:white"  ref="nav">
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                  <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list">
                      <div>
                        {{items.weekstr}}
                      </div>
                      <div style="margin-left:10px">
                          {{items.Stime}}
                      </div>
                      <img v-if="today == items.Stime"  src="../../assets/toady.png" style="margin-left:10px;width:20px;height:20px" alt="" srcset="">
                  </div>
          </div>
          <div class="leftMain" style="width:100%" ref='externalForm' @scroll="exterHandleScroll()" @mouseover="changeFlag(true)">
            <div class="maxw posttrue" >
                  <div class="box flex-xy" style="font-weight:600;font-size:16px">
                      <span v-if="chooseTrue == true">服务人员</span>
                      <span v-else>{{WZXMName}}</span>
                  </div>
                    <div class="box  flexc-cen-x" style="padding-left:15px;font-weight:600;font-size:16px" v-for="(items,index) in timeData" :key="index" ref="list">
                      <div>
                        {{items.weekstr}}
                      </div>
                      <div style="margin-left:10px">
                          {{items.Stime}}
                      </div>
                      <img v-if="today == items.Stime"  src="../../assets/toady.png" style="margin-left:10px;width:20px;height:20px" alt="" srcset="">
                    </div>
            </div>
            <div v-if="chooseTrue == true" class="maxw" v-for="(items,index1) in list">
                    <div class="box1 flex-xy">
                      <div class="flex-spc-x">
                            <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                            <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                            <div style="margin-left:10px">{{items.Name}}</div>
                      </div>
                    </div>
                    <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="(item,index2) in items.ListRowClass">
                        <div class="boxMain " style="height:100%;width:100%">
                          <div class="flex-xy" style="height:85%;width:100%">
                            <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                              <el-popover
                                v-if="it.color && it.isyuyue == 1  && it.allcount == 0 && it.RowClassTypeqt == 1 "
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                        </div>
                                        <div style="font-size:13px">已预约:<span class="coBlue">{{it.allcount}}人</span></div>
                                    
                                      </div>
                                      <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-user"></i> 
                                        <span>{{it.terName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                    
                                  </div>
                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                        <div class="qiu" :style="{'background':it.color}">
                                        </div>
                                        <div style="margin-left:10px;color:#d9d9d9">
                                          {{it.ProjectName}}
                                        </div>
                                        
                                      </div>
                                    <div class="count flex-xy" v-if="it.allcount !=0">{{it.allcount}}</div>
                                    
                                    </div>
                              </el-popover>
                              <el-popover
                                v-if="it.color && (it.isyuyue != 1 || it.allcount != 0)"
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                        </div>
                                        <div style="font-size:13px">已预约:<span class="coBlue">{{it.allcount}}人</span></div>
                                    
                                      </div>
                                      <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-user"></i> 
                                        <span>{{it.terName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%" >
                                          <el-button type="text" @click="toEdit(it)" v-if="q1 == true">预约</el-button>
                                      </div>
                                  </div>
                                  <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                        <div class="qiu" :style="{'background':it.color}">
                                        </div>
                                        <div style="margin-left:10px">
                                          {{it.ProjectName}}
                                        </div>
                                      </div>
                                        <div class="count flex-xy" v-if="it.allcount !=0">{{it.allcount}}</div>
                                  </div>
                              </el-popover>
                            </div>
                          </div>
                          <div class="flexc-spc-x">
                            <el-popover
                            v-if="item.ListRowClassSub.length>4"
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%;height:300px; overflow: auto;">
                                      <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img :src="it.ProjectHeadUrl" alt="" style="width:35px;height:35px">
                                          <div style="font-size:15px;margin-left:10px">{{it.ProjectName}}</div>
                                        </div>
                                        <div style="font-size:13px">已预约:<span class="coBlue">{{it.allcount}}人</span></div>
                                    
                                      </div>
                                        <div v-if="it.terName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-user"></i> 
                                          <span>{{it.terName}}</span>
                                        </div>
                                        <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-location-outline"></i> 
                                          <span>{{it.SiteName}}</span>
                                        </div>
                                        <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                          <i class="el-icon-time"></i> 
                                          <span>{{it.startTime}}</span>
                                        </div>
                                        <div class="flex-r-x" style="width:100%">
                                            <el-button type="text" v-if="q1 == true" @click="toEdit(it)">预约</el-button>
                                          
                                        </div>
                                      </div>
                                    
                                  </div>
                                    <div class="quanbu1 cursor"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                                    
                                </el-popover>
                                  <div class="quanbu cursor" v-if="JSON.stringify(item.ListRowClassSub[0]) != '{}' && q1 == true "  style="margin-left:160px" @click="toyue(item,index1,index2)">+预约</div>
                          </div>
                        
                        </div>
                    </div>
                    
            </div>
            <div v-if="chooseTrue == false" class="maxw" v-for="(items,index1) in list">
                    <div class="box1 flex-xy">
                      <div class="flexc-cen-x">
                            <img v-if="items.HeadUrl" :src="items.HeadUrl" alt="" style="width:40px;height:40px;border-radius:100%">
                            <img v-if="!items.HeadUrl" src="../../assets/img/head.png" alt="" style="width:40px;height:40px;border-radius:100%">
                            <div style="margin-left:10px">{{items.ProjectName}}</div>
                      </div>
                    </div>
                    <div class="box1  flexc-cen-x" style="padding-left:15px" v-for="(item,index2) in items.ListRowClass">
                        <div class="boxMain " style="height:100%;width:100%">
                          <div class="flex-xy" style="height:85%;width:100%">
                            <div v-for="(it,index) in item.ListRowClassSub" v-if="index <4" >
                              <el-popover
                              v-if="it.terName && it.isyuyue == 1  && it.allcount == 0 && it.RowClassTypeqt == 1 "
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                          <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                      
                                          <div style="font-size:15px;margin-left:10px;">{{it.terName}}</div>
                                        </div>
                                      
                                            <div style="font-size:13px">已预约:<span class="coBlue">{{it.allcount}}人</span></div>
                                      </div>
                                      <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-document"></i> 
                                        <span>{{it.ProjectName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div> 
                                  </div>
                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                          <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:20px;height:20px;border-radius:100%">
                                          <img v-else src="../../assets/img/head.png" alt="" style="width:20px;height:20px;border-radius:100%">
                                      <div style="margin-left:10px;color:#d9d9d9">
                                        {{it.terName}}
                                      </div>
                                      </div>
                                    </div>
                                </el-popover>
                              <el-popover
                              v-if="it.terName  && (it.isyuyue != 1 || it.allcount != 0)"
                    
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%">
                                      <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                        <div class="flexc-cen-x">
                                          <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                          <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                      
                                          <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                        </div>
                                      
                                            <div style="font-size:13px">已预约:<span class="coBlue">{{it.allcount}}人</span></div>
                                      </div>
                                      <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-document"></i> 
                                        <span>{{it.ProjectName}}</span>
                                      </div>
                                      <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                        <i class="el-icon-location-outline"></i> 
                                        <span>{{it.SiteName}}</span>
                                      </div>
                                      <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                        <i class="el-icon-time"></i> 
                                        <span>{{it.startTime}}</span>
                                      </div>
                                      <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q1 == true">预约</el-button>
                                        
                                      </div>
                                  </div>

                                    <div class="flex-spc-x hov"  slot="reference" style="height:25px;width:190px;border-radius:2px">
                                      <div class="flexc-cen-x">
                                            <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:20px;height:20px;border-radius:100%">
                                        <img v-else src="../../assets/img/head.png" alt="" style="width:20px;height:20px;border-radius:100%">
                                      <!-- <div class="qiu" :style="{'background':it.color}">
                                      </div> -->
                                      <div style="margin-left:10px">
                                        {{it.terName}}
                                      </div>
                                      </div>
                                  
                                        <div class="count flex-xy" v-if="it.YYCount !=0">{{it.allcount}}</div>
                                    </div>
                                </el-popover>
                            </div>
                          </div>
        
                        <div class="flexc-spc-x">
                          <el-popover
                            v-if="item.ListRowClassSub.length>4"
                                  placement="right-start"
                                  width="220"
                                  trigger="hover">
                                  <div  style="width:100%;height:300px; overflow: auto;">
                                      <div style="width:95%;border-top: 5px solid #e6f7ff" v-for="(it,index) in item.ListRowClassSub" >
                                        <div class="flex-spc-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                          <div class="flexc-cen-x">
                                            <img v-if="it.terHeadUrl !=''" :src="it.terHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                                            <img v-else src="../../assets/img/head.png" alt="" style="width:35px;height:35px;border-radius:100%">
                                        
                                            <div style="font-size:15px;margin-left:10px">{{it.terName}}</div>
                                          </div>
                                          <div style="font-size:13px">已预约:<span class="coBlue">{{it.allcount}}人</span></div>
                                        </div>
                                        <div  style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-document"></i> 
                                          <span>{{it.ProjectName}}</span>
                                        </div>
                                        <div v-if="it.SiteName" style="margin-left:10px;margin-top:10px;font-size:13px">
                                          <i class="el-icon-location-outline"></i> 
                                          <span>{{it.SiteName}}</span>
                                        </div>
                                        <div style="margin-left:10px;margin-top:10px;;font-size:13px">
                                          <i class="el-icon-time"></i> 
                                          <span>{{it.startTime}}</span>
                                        </div>
                                        <div class="flex-r-x" style="width:100%">
                                        <el-button type="text" @click="toEdit(it)" v-if="q1 == true">预约</el-button>
                                          
                                        </div>
                                      </div>
                                    
                                  </div>
                                    <div class="quanbu1 cursor"   slot="reference" >显示全部({{item.ListRowClassSub.length}})</div>
                                    
                          </el-popover>
                                
                                  <div class="quanbu cursor" v-if="JSON.stringify(item.ListRowClassSub[0]) != '{}' && q1 == true " style="margin-left:160px" @click="toyue(item,index1,index2)">+预约</div>
                          </div>

                        </div>
                    </div>
                    
              </div>
          </div>
        </div>
      </div>
  </div>
  
  <el-drawer :wrapperClosable= false title="预约选择" :visible.sync="editShow" :direction="direction" size="80%">
      <div class="flex-spc-x">
        <div class="flexc-cen-x" style="margin-left:15px">
            <img :src="showList.ProjectHeadUrl"  style="width:40px;height:40px;border-radius:100%" alt="">
            <div style="margin-left:10px;font-size:16px;font-weight:600">
                      {{showList.ProjectName}}
            </div>
            <div style="margin-left:10px">时长:{{showList.Timelength}}分钟</div>
            <div style="margin-left:10px;margin-top:3px">({{showList.startTime}})</div>
        </div>
        <div class="flexc-cen-x">
          <div class=""><span class="yueren">{{allcount}}人</span><span v-if="showList.RowClassTypeqt != 1 && type == 1" class="yiyue"> / {{showList.limitCount}}席</span></div>
          <el-button bian size="mini" @click="tochooseObj()" v-if="q1 == true" type="primary" style="margin-right:20px;margin-left:10px">添加预约</el-button>
          <el-button bian size="mini" @click="showpaidui()" v-if="ispaidui==1" type="warning" style="margin-right:20px;margin-left:10px">排队列表</el-button>

        </div>
      </div>
      <div class="flexc-cen-x">
          <div style="margin-left:65px;font-size:16px;">
           {{WZYGName}}： {{showList.terName}}
          </div>
      </div>
      <el-table :data="studentList" style="width:100%;margin-top:30px" max-height="480" >
          
            <el-table-column fixed prop="Name" label="预约人" align="center" >
            </el-table-column>
            <!-- <el-table-column fixed prop="PreAboutCount" label="预约人数" align="center" >
            </el-table-column> -->
            <el-table-column fixed prop="PreAboutCount" label="预约人数" align="center" >
             <template slot-scope="scope"> 
                <div class="flex-xy" @click="toNumber(scope.row)" v-if="scope.row.state == 1">
                  <div class="flexc-cen-x">
                    <div style="width:30px;color:#409EFF">{{scope.row.PreAboutCount}}</div>
                    <el-button type="text" icon="el-icon-edit"></el-button>
                  </div>
                </div>
                <div class="flex-xy"  v-if="scope.row.state != 1">
                <div style="width:30px;margin-left:-17px">{{scope.row.PreAboutCount}}</div>
                 
                </div>
            </template>
          </el-table-column>
            <el-table-column fixed prop="Phone" label="电话" align="center" >
            </el-table-column>
            <el-table-column fixed prop="startTimeNew" :label="WZXMName+'时间'" align="center">
            </el-table-column>
            <el-table-column fixed prop="addTime" label="预约时间" align="center" >
            </el-table-column>
            <el-table-column fixed prop="state" label="状态" align="center" >
                <template slot-scope="scope">
                  <span class="Info" v-if="scope.row.state == 0">
                    学员取消
                  </span>
                  <span class="coBlue" v-if="scope.row.state == 1">
                   已预约
                  </span>
                  <span class="Success" v-if="scope.row.state == 2">
                    已{{typeName}}
                  </span>
                  <span class="Danger" v-if="scope.row.state == 3">
                   未到
                  </span>
                  <span class="Info" v-if="scope.row.state == 4">
                    机构取消
                  </span>
                  <span class="Warning" v-if="scope.row.state == 5">
                   请假
                  </span>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center" width="320">
              <template slot-scope="scope" >
                <el-button size="mini" type="primary" v-if="scope.row.state == 2 && q2 == true"   @click="dian(scope.row)" >点评</el-button>
                <!-- <el-button size="mini" type="primary" v-if="scope.row.state != 2 && q2 == true" disabled @click="dian(scope.row)" >点评</el-button> -->
                <el-button size="mini" type="success" v-if="scope.row.state == 1 && q3 == true"   @click="hexiao(scope.row)" >{{typeName}}</el-button>
                 <!-- <el-button size="mini" type="success" v-if="scope.row.state != 1 && q3 == true"  disabled  @click="hexiao(scope.row)" >{{typeName}}</el-button> -->
                <el-button size="mini" type="success" v-if="(scope.row.state == 2||scope.row.state == 3 || scope.row.state == 5) && q10 == true" @click="chexiao(scope.row)" >撤销</el-button>
                <el-button size="mini" type="warning" v-if="scope.row.state == 1 && q4 == true" @click="toOther(scope.row)" >其他</el-button>
                <!-- <el-button size="mini" type="warning" disabled v-if="scope.row.state != 1 && q4 == true" @click.native.prevent="todel(scope.row)" >其他</el-button> -->
                <el-button v-if="scope.row.state == 1 && q5 == true" @click.native.prevent="todel(scope.row)"  type="info" size="mini">取消预约</el-button>
                <!-- <el-button disabled v-if="scope.row.state != 1  && q5 == true" @click.native.prevent="todel(scope.row)"  type="info" size="mini">取消预约</el-button> -->
              </template>
            </el-table-column>
      </el-table>

        <!-- <div class="demo-drawer__footer flex-r-x"  style="width:80%">
          <el-button size="small" @click="editShow = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="sub('editForm')"
            >保存</el-button
          >
        </div> -->
    </el-drawer>
     <el-dialog title="预约" :visible.sync="personShow" width="850px">
        <div style="height:450px">
          <el-table :data="tableData" style="width: 100%" max-height="400">
            <el-table-column fixed prop="ProjectName" :label="WZXMName+'名称'" width="190" >
              <template slot-scope="scope">
                <div class="flexc-cen-x">
                  <img :src="scope.row.ProjectHeadUrl" alt="" style="width:35px;height:35px;border-radius:100%">
                  <div style="margin-left:5px">{{scope.row.ProjectName}}</div>
                  <div v-if="scope.row.RowClassTypeqt == 1">(全天)</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed prop="terName" :label="WZYGName" align="center" >
            </el-table-column>
            <el-table-column fixed prop="SiteName" :label="WZCDName" align="center" v-if="IsCD == 1">
            </el-table-column>
            <el-table-column fixed prop="YYCount" label="预约人数" align="center"  v-if="type==1">
            </el-table-column>
              <el-table-column fixed prop="allcount" label="预约人数" align="center"  v-if="type==2">
            </el-table-column>
            <el-table-column fixed prop="Timelength" :label="WZXMName +'时长'" align="center" >
            </el-table-column>
            <el-table-column fixed prop="startTime" :label="WZXMName +'时间'" align="center" width="110">
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <el-button @click.native.prevent="toEdit(scope.row)" disabled v-if="q1 == true && scope.row.isyuyue == 1 && scope.row.YYCount == 0 " size="mini" type="primary"> 预约 </el-button>
                <el-button @click.native.prevent="toEdit(scope.row)" v-if="q1 == true && (scope.row.isyuyue != 1 || scope.row.YYCount != 0 )" size="mini" type="primary"> 预约 </el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
    </el-dialog>
     <el-dialog title="添加预约" :visible.sync="yuyueShow"   width="600px">
        <el-form label-width="100px" :model="editForm"  style="max-height:55vh;overflow:auto">
          <el-form-item :label="WZXMName+':'" prop="ProjectName">
            <div class="flexc-cen-x" >
              <img :src="showList.ProjectHeadUrl"  style="width:40px;height:40px;border-radius:100%" alt="">
              <div style="margin-left:10px;font-size:16px;font-weight:600">
                          {{showList.ProjectName}}
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="WZXMName+'时长'+':'" prop="ProjectName">
              <div>{{showList.Timelength}}分钟</div>
          </el-form-item>
          <el-form-item :label="WZXMName+'时间:'"  v-if="type == 1" prop="ProjectName">
               <div >{{showList.startTime}}</div>
          </el-form-item>
           <el-form-item label="选择时间:" prop="" v-if="type == 2">
              <el-select v-model="timeID" placeholder="请选择" size="small" style="width:160px">
                <el-option
                  v-for="item in timeList"
                  :key="item.ID"
                  :label="item.time"
                  :value="item.ID">
                </el-option>
              </el-select>
           </el-form-item>
            <el-form-item :label="'选择'+WZHYName +':'" prop="">
              <span>{{vipName}}<span v-if="vipPhone !=''">({{vipPhone}})</span></span>
              <el-button style="margin-left:10px"  type="text"  @click="toVipShow">选择</el-button>
            </el-form-item>
            <el-form-item label="选择子账号:" v-if="subList.length>0" clearable>
              <el-select v-model="MembersSubID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in subList"
                  :key="item.ID"
                  :label="item.Name"
                  :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择会员卡:" v-if="isCard == 1">
              <el-select v-model="vipID" placeholder="请选择" size="small" style="width:300px">
                <el-option
                  v-for="item in cardList"
                  :key="item.vipID"
                  :label="item.CardName"
                  :value="item.vipID">
                </el-option>
              </el-select>

           </el-form-item>
          <el-form-item label="预约方式:" prop="isCode" v-if=" isCard == 0">
              <el-radio-group v-model="vipID">
                <el-radio :label="-1">储蓄卡</el-radio>
                <el-radio :label="-2">储次卡</el-radio>
          </el-radio-group>
          </el-form-item>
           <el-form-item label="预约人数:">
              <el-input-number v-model="PreAboutCount" size="small"  :min="1" :step="1"  style="width:160px"></el-input-number>
           </el-form-item>
           <div v-if="showList.isPreAboutInfo == 1 && preAbout == true" :key="timer">
            <el-form-item  v-for="(item,index) in ListPreAboutForms" :label="item.Title" :key="index">
              <div class="flexc-cen-x"  v-if="item.fType == 2">
                  <el-date-picker
                    @input="forceUpdate"
                    v-model="ListPreAboutForms[index].date"
                    style="width:200px"
                    type="date"
                     size="small"
                    placeholder="选择日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                    <el-select   v-model="ListPreAboutForms[index].time" size="small" style="width:90px;margin-left:5px" filterable  @input="forceUpdate">
                      <el-option  v-for="item in coursetime" 
                              :value="item.value" 
                              :label="item.label" 
                              :key="item.value">
                            </el-option>
                        </el-select>   
                        <span style="margin-left:5px;margin-right:5px">:</span>
                    <el-select size="small" v-model="ListPreAboutForms[index].time1" style="width:90px;" filterable  @input="forceUpdate">
                            <el-option v-for="item in coursetminu" :value="item.value" :label="item.label" :key="item.value">
                            </el-option>
                        </el-select> 
                <span v-if="item.isbt == 1" style="color:red;margin-left:5px">*</span>

              </div>


                  <el-input style="width:200px"   v-if="item.fType == 1" v-model="ListPreAboutForms[index].info" :key="timer" size="small" placeholder="请输入内容"    @input="forceUpdate"></el-input>
                  <span v-if="item.isbt == 1 && item.fType == 1" style="color:red">*</span>
           </el-form-item>
           </div>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="yuyueShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="subm()">保存</el-button>
        </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZHYName" :visible.sync="vipShow"  >
      <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:-20px">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="selectName" placeholder="输入姓名、手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search1">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table  :data="vipList" highlight-current-row  max-height="400" style="width: 100%;">
          <el-table-column  prop="Name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:50px;height:50px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:50px;height:50px;border-radius:100%" alt="">
                <div style="margin-top:5px;font-size:15px">{{scope.row.Name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="手机号"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0"  prop="czAmount" label="储蓄金额(元)"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0" prop="syNumber" label="次卡次数"  align="center">
          </el-table-column>

          

        <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.row)">选择</el-button>
        
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-dialog>
    <el-dialog :title="typeName" :visible.sync="hexiaoShow" width="40%" >
      
      <el-form label-width="120px" >
        <!-- <el-form-item :label="'使用'+typeName+'码:'" prop="isCode" v-if="mainList.isZF != 1 &&  (cardList.length != 0 &&  isCard == 1)">
          <el-radio-group v-model="isCode">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>  -->
        <el-form-item :label="typeName+'码'" prop="number" v-if="isCode == 1">
          <el-input size="small" placeholder="请输码" v-model="code"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="会员卡:" prop="number" v-if=" isCode == 0 && isCard == 1 &&  mainList.vipID !=0 ">
            <el-select v-if="issfxk==0" v-model="mainList.vipID" placeholder="请选择" size="small" @change="tochoosevip(1)">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName + '/' + item.name"
                :value="item.ID">
              </el-option>
          </el-select>
         <span v-if="issfxk==1">{{mainList.vipName}} {{mainList.kyName}}</span>  
        </el-form-item>
        <el-form-item label="使用会员卡:" prop="number" v-if="isCode == 0 && mainList.vipID == 0" >
          <el-radio-group v-model="isUser">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> 
        <el-form-item label="选择会员卡:" v-if=" isUser == 1 && isCode == 0 && mainList.vipID == 0">
          <el-select v-model="vipID" placeholder="请选择" size="small" @change="tochoosevip()">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName + '/' + item.name"
                :value="item.ID">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣金额:" prop="number" v-if="isUser == 1 && isCode == 0 && (cardType == 4 || cardType == 5) && mainList.vipID ==0">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元 &nbsp;<span v-if="iskczk==1">(原价：{{mainList.xhAmount}} 元)</span>
          </el-form-item>
        <el-form-item label="扣次数:" prop="number" v-if="isUser == 1 && isCode == 0 && (cardType == 1 || cardType == 2) && mainList.vipID ==0" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="扣金额:" prop="number" v-if="isCard == 0 && isCard == 0 && isCode == 0 && mainList.vipID == -1">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元 &nbsp;<span v-if="iskczk==1">(原价：{{mainList.xhAmount}} 元)</span>
        </el-form-item>
        <el-form-item label="扣次数:" prop="number" v-if=" isCard == 0 && isCode == 0 && mainList.vipID == -2 " >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item> 
        <el-form-item label="扣金额:" prop="number" v-if="isCard == 1 && (mainList.CardType ==4 ||mainList.CardType ==5 ) && isCode == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元 &nbsp;<span v-if="iskczk==1">(原价：{{mainList.xhAmount}} 元)</span>
        </el-form-item>
        <el-form-item label="扣次数:" prop="number" v-if=" isCard == 1 && isCode == 0 &&(mainList.CardType ==2 ||mainList.CardType ==1) " >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item> 
        <el-form-item label="预约人数:" prop="Note">
            <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
        </el-form-item>
         <el-form-item :label="'选择'+WZYGName +':'" prop="number" >
            <span>{{mainList.terName}}</span>
            <el-button type="text" style="margin-left:20px" @click="handlePassword1">选择</el-button>
        </el-form-item>
        <!-- <el-form-item label="金额" prop="number" v-if="isCard == 1 && (mainList.CardType ==4 ||mainList.CardType ==5 ) && isCode == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
        <el-form-item label="次数" prop="number" v-if=" isCard == 1 && isCode == 0 &&(mainList.CardType ==2 ||mainList.CardType ==1) " >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>  -->
        <!-- <el-form-item label="金额" prop="number" v-if="mainList.vipID == -1 && isCode == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
          元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if="mainList.vipID != -1 && isCode == 0" >
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item> -->
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="hexiaoShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sure()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="其他操作" :visible.sync="otherShow" width="40%" >

      <el-form label-width="120px">
        <el-form-item label="原因："  prop="state">
            <el-select v-model="state" clearable placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
        </el-form-item>
        <el-form-item label="扣课时:" prop="isxk">
          <el-radio-group v-model="isxk">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="选择会员卡:" v-if="isxk == 1   && mainList.vipID ==0">
          <el-select v-model="vipID" placeholder="请选择" size="small" @change="tochoosevip()">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName"
                :value="item.ID">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if=" isxk == 1 && (cardType == 4 || cardType == 5) && mainList.vipID ==0">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
        <el-form-item label="次数" prop="number" v-if="isxk == 1 && (cardType == 1 || cardType == 2) && mainList.vipID ==0" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if="mainList.vipID == -1 && isxk == 1 && isCard == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
          元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if="mainList.vipID != -1 && isxk == 1 && isCard == 0" >
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if="(mainList.CardType == 4 || mainList.CardType == 5)&& isxk == 1 && isCard == 1">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
          元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if="(mainList.CardType == 1 || mainList.CardType == 2) && isxk == 1 && isCard == 1" >
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="otherShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sure1()">确定</el-button>
      </div>
    </el-dialog>
    <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="点评详情"
            direction="ltr"
            size="50%"
            :visible.sync="showRightDrawer3"
      
            >
            <div class="drawerForm">
                <el-form   label-width="100px" label-position="right">
                  <el-form-item label="点评内容:" prop="Note">
                    <el-input type="textarea" :rows="2" placeholder="请输入点评内容" v-model="info"  style="width:90%"></el-input>
                </el-form-item>
                    <el-form-item label="图片：" prop="ImgUrl">
                       <el-upload
                            :action="URL"
                            list-type="picture-card"
                            :file-list="fileList"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove1"
                            :http-request="imageChange"
                            :before-upload="beforeUp"
                            >
                            <!-- :on-success="handleAvatarSuccess" -->
                            <i class="el-icon-plus"></i>
                        </el-upload>
                     </el-form-item>
                </el-form>
            </div>
                   <div class="demo-drawer__footer flex-r-x"  style="width:50%">
          <el-button size="small" @click="showRightDrawer3 = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
    
        
            @click="sureReview()"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-dialog  class="normalDrawer"
        direction="ltr"
        :visible.sync="dialogVisible1">
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog title="撤销" :visible.sync="cheShow" width="40%">
        <el-form label-width="120px">
          <el-form-item label="撤销原因:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入原因" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cheShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureChe()">确定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="选择预约人数" :visible.sync="numberShow" width="500px" @click="numberShow= false">
        <el-form label-width="120px">
          <el-form-item label="预约人数:" prop="Note">
              <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="numberShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureNumber()">确定</el-button>
        </div>
    </el-dialog>
        <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow1" width="500px" @click="personShow1= false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
    <el-dialog title="排队列表" :visible.sync="showPreAboutPD"  >
 
      <el-table  :data="PreAboutPDList" highlight-current-row  max-height="400" style="width: 100%;">
          <el-table-column  prop="Name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:50px;height:50px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:50px;height:50px;border-radius:100%" alt="">
                <div style="margin-top:5px;font-size:15px">{{scope.row.Name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="手机号"  align="center">
          </el-table-column>
          <el-table-column fixed prop="startTimeNew" :label="WZXMName+'时间'" align="center">
            </el-table-column>
          <el-table-column  prop="addTime" label="排队时间"  align="center">
          </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handledelPreAboutPD(scope.row)">取消排队</el-button>
        
          </template>
        </el-table-column>
      </el-table>
  
      <Pagination v-bind:child-msg="pageparm1" @callFather="callFatherPD"></Pagination>
    </el-dialog>
  </div>
</template>
<script src="https://cdn.bootcss.com/jquery/3.2.1/jquery.js"></script>
<script>
var throttle = require('lodash/throttle')
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import { baseUrl } from "../../config/env.js";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
import draggable from 'vuedraggable'
import * as imageConversion from 'image-conversion'
export default {
  data() {
    return {
      vipShow:false,
      day:'',
      info:'',
      numberShow:false,
      chooseTrue:true,
      hexiaoShow:false,
      vipList:[],
      PreAboutPDList:[],
      vipName:'',
      PreAboutCount:1,
      isCode:0,
      vipID:'',
      Note:'',
      isFixed: false, //是否固定的
      throttleScroll: null, //定义一个截流函数的变量
      preAbout:false,
      flag:false,
      dialogImageUrl:'',
      issfxk:localStorage.getItem("issfxk"),
      IsCD:localStorage.getItem("IsCD"),
      iskczk:localStorage.getItem("iskczk"),
      WZCDName:localStorage.getItem('WZCDName'),
      RowTypeList:[],
      dayList:[
          '周日',
          '周一',
          '周二',
          '周三',
          '周四',
          '周五',
          '周六',
        ],
        subList:[],
        RowClassTimeShow:false,
        siteList:[],
        isEditqt:false,
        editShow:false,
        site:'',
        personName:'',
        thier:'',
        coursetime:[{
          value: '00',
          label: '00'
        }, {
          value: '01',
          label: '01'
        }, {
          value: '02',
          label: '02'
        }, {
          value: '03',
          label: '03'
        }, {
          value: '04',
          label: '04'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '06',
          label: '06'
        }, {
          value: '07',
          label: '07'
        }, {
          value: '08',
          label: '08'
        }, {
          value: '09',
          label: '09'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }, {
          value: '13',
          label: '13'
        }, {
          value: '14',
          label: '14'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '16',
          label: '16'
        }, {
          value: '17',
          label: '17'
        }, {
          value: '18',
          label: '18'
        }, {
          value: '19',
          label: '19'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '21',
          label: '21'
        }, {
          value: '22',
          label: '22'
        }, {
          value: '23',
          label: '23'
        }],
        coursetminu:[{
          value: '00',
          label: '00'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '25',
          label: '25'
        }, {
          value: '30',
          label: '30'
        }, {
          value: '35',
          label: '35'
        }, {
          value: '40',
          label: '40'
        }, {
          value: '45',
          label: '45'
        }, {
          value: '50',
          label: '50'
        }, {
          value: '55',
          label: '55'
        }],
        CycleList:[
                    {Id:"1",Label:"周一"},
                    {Id:"2",Label:"周二"},
                    {Id:"3",Label:"周三"},
                    {Id:"4",Label:"周四"},
                    {Id:"5",Label:"周五"},
                    {Id:"6",Label:"周六"},
                    {Id:"7",Label:"周日"}
        ],

        checkedCycles:[],
   
      objShow:false,
      listRowClassTimeQT:[],
      listRowClassTime:[],
      list:[],
      direction: "ltr",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      date:'', 
      LoginIDs:[],
      vipID:'',
      isUser:0,
      ispaidui:localStorage.getItem("ispaidui"),
      SelectStoresID:localStorage.getItem("StoresID"),
      startTimenew:"08:00",
      isCard:localStorage.getItem("isCard"),
      RowClasendTime:"",
      studentList:[],
      cardList:[],
      ListPreAboutForms:[],
      editForm: {
        shour:'',
        sminute:'',
        RowClassType:1,
        SiteName:'',
        isPreAboutInfo:0,
        ListPreAboutForms:[],
        ListRowClassTime:" ",
        LoginIDs:'',
        Timelength:'',
        objID:'',
        RowClassTypeqt:'1',
        xhAmount:0,
        payPrice:0,
        iscx:'1',
        isck:'0',
        xhnumber:0,
        Timelengthqt:30,
        integral:0,
        IsPay:'0',
        PreAboutType:1,
        // preferentialType:0,
        // LevelName:'',
        // preferentialvalue:'',
      },
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q10:false,
      typeName:'',
      selectName:'',
      vipitems:"",
      timeData:[],

      // rules表单验证
    preShow:false,
    title:'',
      rules: {
        Cycle:[{ required: true, message: '请选择周期', trigger: 'blur' }],
        objID: [{ required: true, message: '请选择项目', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit:10,

      },
      timechoose:[
          {
          value:15,
        },
        {
          value:30,
        },
        {
          value:45,
        },
        {
          value:60,
        },
         {
          value:90,
        },
         {
          value:120,
        }
      ],
       lay:[
        {
          value:'1',
          label:'必填'
        },
            {
          value:'0',
          label:'选填'
        }
      ],
            stateList:[
     
        {
          value:3,
          label:'未到'

        },
      
         {
          value:5,
          label:'请假'

        },
      ],
          otherShow:false,
      isxk:0,
      state:'',
      timer:'',
      allcount:0,
      dianShow:false,
      MembersSubID:'',
      subName:'',
      code:'',
      isEdit:false,
      objitems:{},
      personList:[],
      tableData:[],
      timeID:'',
      showList:{},
      timeList:[],
      vipPhone:'',
      cheShow:false,
      yuyueShow:false,
      Site:'',
      cd:false,
      flag:false,
      LoginID:-1,
      money:0,
      number:0,
      objID:'',
      today:'',
      addshow:false,
      dialogVisible1:false,
      URL: baseUrl + "upload_images.aspx",
      limitCount:1,
      MinCount:1,
      mainList:{},
      fileList:[],
      pinList:{},
      index1:'',
      index2:'',
      type:2,
      cardType:'',
      showRightDrawer3:false,
      showPreAboutPD:false,
      RowType:'',
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      
      ziShow:false,
      personShow:false,
        personShow1:false,
      GoodsList:[],
      userparm: [], //搜索权限
      listData: [], //用户数据
      ListPreAboutForms:[],
         WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
         total:0,
      
      },
      pageparm1: {
        currentPage: 1,
        pageSize: 10,
         total:0,
      
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      this.WZYGName = localStorage.getItem('WZYGName')
      this.WZHYName = localStorage.getItem('WZHYName')
      this.WZXMName = localStorage.getItem('WZXMName')
      this.WZPBName = localStorage.getItem('WZPBName')
          if(localStorage.getItem('StoresType')== 1){
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
        
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q10 = true
      }
  this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 42){
            this.q1 = true
          }
          if(items == 43){
            this.q2 = true
          }
          if(items == 44){
            this.q3 = true
          }
          if(items == 45){
            this.q4 = true
          }
          if(items == 46){
            this.q5 = true
          }
          if(items == 47){
            this.q10 = true
          }
         
   })
    var date = new Date();
    var year = date.getFullYear(); //获取完整的年份(4位)
   var mounth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    var day =   date.getDate(); //获取当前日(1-31)
    this.date = year + '-' + mounth + '-' + day
     
    if(mounth<10)
    mounth = '0' +  mounth
      if(day<10)
        day = '0' +  day
    this.today = year + '-' + mounth + '-' + day
    console.log(this.today)
    //    this.getType()
    this.getList()
    this.getDianList()
    this.getRowType()
    this.getPersonList()
    this.getProjectList()
    this.getSiteList()
    this.getvipList()
      // var myDate = new Date();
      // if(myDate.getHours() <10){
      //   var hour = '0' + myDate.getHours() 
      // } else {
      //   var hour =  myDate.getHours() 
      // }
      // if(myDate.getMinutes()<10){
      //   var minute = '0' + myDate.getMinutes()
      // } else {
      //   var minute =  myDate.getMinutes()
      // }
      // var time = hour + ':' + minute
         
      // //  console.log(time)
      // for( var i = 0;i<this.timeData.length;i++){
      //     if(time < this.timeData[i].startTime)
      //       {
      //         var t = i 
      //         break
      //       }
      // }
      // this.$nextTick(()=>{
      //   var loading = this.$loading({
      //         lock: true,
      //         text: '加载中...',
      //         spinner: 'el-icon-loading',
      //         background: 'rgba(0, 0, 0, 0.7)'
      //       });
    
      //   this.$refs.list1.forEach((item,index)=>{
      //       if(index  == t){
      //           this.cd = false
      //           item.scrollIntoView({ behavior: "auto",block: "start",inline:'center'})
      //           loading.close()
      //       }
        
        
      //     })
      //     loading.close()
      //   })

  },

  methods: {
          beforeUp(file){
                const isLt2M = file.size / 1024 / 1024 < 10;
                
                    if (!isLt2M) {
                        this.$message.error('上传头像图片大小不能超过 10MB!');
                        return(false)
                } 


                return new Promise((resolve, reject) => {
                
                        console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
                        imageConversion.compressAccurately(file, 1000).then(res => { // console.log(res)
                        res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
                        console.log('压缩后', res)
                        resolve(res)
                        })
                    

                      
                })
            },
       choose(items){
          this.mainList.terName = items.Name
          this.mainList.StaffID = items.ID
          this.personShow1 = false

      },
        sureNumber(){
       var that = this
   
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              PreAboutCount:this.mainList.PreAboutCount
            }
         
            this.ajax('editPreAboutCount.aspx',JSON.stringify(data),"POST",function(res){
              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "修改成功",duration:2000
                  });
                  that.numberShow = false
                  that.getListPreAboutStu()
                 
                }
            })
        // PreAboutCount
    },
    toNumber(row){
      this.mainList =row
      this.numberShow = true
    },
        handlePassword1(){

        this.personShow1 = true

    },
    chexiao(row){
        this.mainList = row
        this.cheShow = true
        this.Note = ''
    },
    sureChe(){
      if(this.Note == ''){

         this.$message({ type: "error", message: "请选择原因" ,duration:1000});
                  return;

      }
      var that = this
          if(this.mainList.isZF == 1){
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutPay.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000
                  });
                  that.cheShow = false
                  that.getListPreAboutStu()
                 
                }
            })
          
          }  else {
           if(this.isCard == 1){
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:this.mainList.ID,
                loginName:localStorage.getItem("Name"),
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
              }
              this.ajax('RevocationPreAbout.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {

                    that.$message({
                      type: "success",
                      message: "撤销成功",duration:2000
                    });
                   that.cheShow = false
                  that.getListPreAboutStu()
                    //  that.provinceList = res.data
                  }
              })
           } else {
               var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutNoCrad.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000
                  });
                  that.cheShow = false
                  that.getListPreAboutStu()
                  //  that.provinceList = res.data
                }
            })
          
           }
        }
    },
    tochoosevip(items){

      if(items == 1){
           this.cardList.forEach(items=>{
                if(this.mainList.vipID == items.ID){
                        this.mainList.CardType = items.CardType
        
                }
              })
      } else {
      this.cardList.forEach(items=>{
                if(this.vipID == items.ID){
                        this.cardType = items.CardType
                      
                }
              })
            }
       
    },
    // tochoosevip(){
    //     this.cardList.forEach(items=>{
    //       if(this.vipID == items.ID){
    //               this.cardType = items.CardType
                 
    //       }
    //     })
    // },
    getRowType(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.RowTypeList= res.data
    
          } 
       })
    },
    changeType(){
        
        console.log(this.type)
        if(this.type == 1){
            this.cd = false
            this.getList()
         
            // this.isweek  = 0
        } else {
            this.$refs.nav.scrollLeft =0 
            this.$refs.externalForm.scrollLeft = 0
            this.cd = false
            this.isweek  = 0
            this.getList()
          
        }
    },
    sureReview(){
      var list = []
       this.fileList.forEach(items => {
        list.push(items.url)
      }); 
      console.log(list)
      if(this.info == '' && this.fileList.length == 0){
              this.$message({ type: "error", message: "请输入点评" ,duration:1000});
                return;
        } else {
          if(this.addshow == true){
                var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                StudentID:this.mainList.MembersID,
                RowClassID:this.mainList.RowClassID,
                TeacherID:localStorage.getItem("LoginID"),
                ReviewInfo:this.info,
                listimgs:list.join(",")
              
                  }
              var that = this
              this.ajax('addReview.aspx',JSON.stringify(data),"POST",function(res){
                           
                            if (res.orsuccess == "1") {
                               that.showRightDrawer3 = false
                                that.$message({
                              type: "success",
                              message: "点评成功",duration:2000
                            });
                            }
              })
          } else {
            
       var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                StudentID:this.pinList.info.StudentID,
                RowClassID:this.pinList.info.RowClassID,
                TeacherID:localStorage.getItem("LoginID"),
                ReviewInfo:this.info,
                ReviewID:this.pinList.info.ID,
                listimgs:list.join(",")
              
        }
              var that = this
              this.ajax('editReview.aspx',JSON.stringify(data),"POST",function(res){
                           
                            if (res.orsuccess == "1") {
                                 that.showRightDrawer3 = false
                                that.$message({
                              type: "success",
                              message: "点评成功",duration:2000
                            });
                            }
              })
         


          }
        
        }
    },
    handleRemove1(file, fileList) {
          if (file && file.status==="success") {
                  console.log(fileList) 
                  this.fileList = fileList
          }
             
    },

    handlePictureCardPreview(file) {
                 this.dialogImageUrl = file.url;
                   this.dialogVisible1 = true;
    }, 
    imageChange(param,type){
        let formData = new FormData();
        var URL = baseUrl + "upload_images.aspx";
        formData.append('file',param.file)
        formData.append("token",localStorage.getItem("token"));
        this.$axios.post(URL,formData).then((res) =>{
            if(res.data.orsuccess == 1){
                console.log(this.fileList)
                this.fileList.push({url:res.data.url,uid:this.fileList.length + 1,status:"success"})
         }
       })
      },
    dian(row){
      this.mainList = row
      this.getPinList()
       
    },
    getPinList(){
       this.addshow = false
      var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                StudentID:this.mainList.MembersID,
                RowClassID:this.mainList.RowClassID
              
        }
              var that = this
              this.ajax('getReviewinfo.aspx',JSON.stringify(data),"POST",function(res){
                  that.showRightDrawer3 = true
                   that.fileList =[];
                if (res.orsuccess == "1") {
                  if(!res.data.info.StudentID){
                    console.log('22222')
                    that.addshow = true
                    that.info = ''      
                
                 } else {
                   that.info = res.data.info.ReviewInfo
                 }
                  that.GoodsList = res.data.listimge
                  
                      for (let i = 0; i < that.GoodsList.length; i++) {
                        const element = that.GoodsList[i];
                        that.fileList.push({url:element.ImgUrl,uid: element.ID,status:"success"})
                    }
                  that.pinList = res.data
                  that.dianShow = true
                }
          })
  },
    toOther(row){
      this.otherShow = true
      this.mainList = row
      this.state = ''
      this.Note = '',
      this.isxk = 0

      this.money = this.mainList.xhAmountsj
      this.number = this.mainList.xhnumber
      this.isUser = 0
      if(this.isCard == 1){

          this.getListMembersvip1()
      } 
    },
    sure1(){
      console.log(this.state)
      if(this.state == ''){
        this.$message({ type: "error", message: "请选择原因" ,duration:1000});
                          return;
      }
//       if(this.money == 0  && ( this.mainList.CardType == 4 ||this.mainList.CardType == 5) && this.isxk == 1 && this.isCard == 1){
// //         this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
// //                           return;
//       }
//        if(this.number == 0  && (this.mainList.CardType ==2 ||this.mainList.CardType ==1) && this.issk == 1 && this.isCard == 1){
// //         this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
// //                           return;
//       }
    if(this.mainList.vipID == 0 && this.isxk == 1){
          var vipID = this.vipID
      } else  {
        var vipID = this.mainList.vipID
      }
        var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:this.mainList.ID,
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
                sourceName:localStorage.getItem("Name"),
                isxk:this.isxk,
                state:this.state,
                ConsumptionOfClass:this.number,
                singlePrice:this.money,
                vipID:vipID
              
              }
              var that = this
              this.ajax('editPreAboutStateQT.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {
                    that.$message({
                      type: "success",
                      message: "操作成功",duration:2000
                    });
                    that.otherShow = false
                    // that.getType()
                       that.getListPreAboutStu()
                    //  that.provinceList = res.data
                  }

              })
    },
    sure(){

//       if(this.money == 0   && (this.mainList.CardType ==4 ||this.mainList.CardType ==5) && this.isCard == 1 && this.isCode == 0){
// //         this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
// //               return;
//       }
//        if(this.number == 0  && (this.mainList.CardType ==2 ||this.mainList.CardType ==1) && this.isCard == 1 && this.isCode == 0){
// //         this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
// //               return;
//       }
      if(this.code == '' && this.isCode == 1){
        this.$message({ type: "error", message: "请输入码" ,duration:1000});
              return;
      }
      if(this.mainList.vipID == 0){
            var vipID =this.vipID
      } else {

          var vipID = this.mainList.vipID

      }
 this.$confirm('是否确认'+ this.typeName, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:this.mainList.ID,
          loginID:localStorage.getItem("LoginID"),
          Note:this.Note,
          sourceName:localStorage.getItem("Name"),
          isCode:this.isCode,
          VerificationCode:this.code,
          ConsumptionOfClass:this.number,
          singlePrice:this.money,
          vipID:vipID,
          StaffID:this.mainList.StaffID,
          PreAboutCount:this.mainList.PreAboutCount
        }
        var that = this
        this.ajax('editPreAboutState.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000
              });
              that.hexiaoShow = false
               that.getListPreAboutStu()
              // that.getType()
              // that.getList()
              //  that.provinceList = res.data
            }

        })
     
                    }).catch(() => {
                            
                    });


   
    },

     hexiao(row){
      this.mainList = row
        this.mainList.terName = this.showList.terName
        this.mainList.StaffID = this.showList.StaffID
 
      if(this.mainList.vipID == 0){
          this.isUser = 0
          this.vipID = ''
          this.CardType = ''
      }
   if(this.mainList.isZF == 1){
          this.isCode = 1
      } else {
          this.isCode = 0
      }
      this.hexiaoShow = true
      console.log(this.mainList)
      this.money = this.mainList.xhAmountsj
      this.number = this.mainList.xhnumber
      this.vipID = ''
      
        if(this.isCard == 1){

          this.getListMembersvip1()

        } 
    },
    getListMembersvip1(){
         
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID: this.mainList.MembersID
      }

      var that = this
      this.ajax('getListMembersvip.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.cardList =res.data
                that.cardList.forEach(items => {

                  if(items.CardType == 1|| items.CardType == 2){
                    items.name = '可用' + items.CardNumber +'次'
                  }
                  if(items.CardType == 4|| items.CardType == 5){
                    items.name = '可用' + items.Amount +'元'
                  }
                 if(items.CardType == 3){
                   items.name = ' '
                 }
                });
                if(that.cardList.length == 0 && that.mainList.isZF == 1){
                      that.isCode = 1
                }
                if(that.otherShow == false){
                    that.hexiaoShow = true
                }
              
          } 

      })
     this.vipID =''
    },
    forceUpdate() { 
    this.$forceUpdate() 
  },
 changeFlag(flag) {
    this.flag = flag
  },
  // 左右滚动条滚动同步
  sysHandleScroll() {
    if (!this.flag) {
      this.$refs.externalForm.scrollTop = this.$refs.systemForm.scrollTop
    }
  },

  exterHandleScroll() {

    if (this.flag) {
      this.cd = true
       this.$refs.nav.scrollLeft = this.$refs.externalForm.scrollLeft
       this.$refs.systemForm.scrollTop = this.$refs.externalForm.scrollTop
    }
  
  },

    todel(items){
      if(items.isZF == 1){
        this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:items.ID,
              loginID:localStorage.getItem("LoginID"),
              Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateTK.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000
                  });
            
                 that.getList()
              that.getListPreAboutStu()
              if(that.index1 !=''){
              
                    that.tableData = that.list[that.index1].ListRowClass[that.index2].ListRowClassSub
      
                  }
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {

            });
      

      } else {
      if(this.showList.RowClassTypeqt == 1){ 
           this.$confirm("确定要取消预约吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:items.ID,
          loginID:localStorage.getItem("LoginID"),
          Note:'',
        }
        var that = this
        this.ajax('editPreAboutStateQXQT.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "取消成功",duration:2000
              });
        
              that.getList()
              that.getListPreAboutStu()
              if(that.index1 !=''){
              
                    that.tableData = that.list[that.index1].ListRowClass[that.index2].ListRowClassSub
      
              }
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   

           } else{
              this.$confirm("确定要取消预约吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = {
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            PreAboutID:items.ID,
            loginID:localStorage.getItem("LoginID"),
            Note:'',
        }
        var that = this
        this.ajax('editPreAboutStateQX.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "取消成功",duration:2000
              });
        
              that.getList()
              that.getListPreAboutStu()
              if(that.index1 !=''){
              
                    that.tableData = that.list[that.index1].ListRowClass[that.index2].ListRowClassSub
      
                  }
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
          });
        }
      }

    },
    inp(){
         this.timer = new Date().getTime()
    },
    subm(){
      var infoList = []
          if(this.showList.isPreAboutInfo == 1){
            for(var i = 0;i<this.ListPreAboutForms.length;i++){
              if(this.ListPreAboutForms[i].fType != 2){
                var t = {
                      FormsID:this.ListPreAboutForms[i].ID,
                      FormsInfo:this.ListPreAboutForms[i].info
                }
              } else {
                 var t = {
                  FormsID:this.ListPreAboutForms[i].ID,
                  FormsInfo: this.ListPreAboutForms[i].date + ' ' + this.ListPreAboutForms[i].time +':' + this.ListPreAboutForms[i].time1 
                }
              }
            infoList.push(t)
      }
    }
  
    console.log(infoList)
       var RowClasendTime = ''
    if(this.vipID === ''){
                   this.$message({ type: "error", message: "请选择会员卡" ,duration:1000});
                  return;
      }
      if(this.showList.RowClassTypeqt == 1){
        if(this.type== 1){
           RowClasendTime  = this.showList.RowClassTimeID
        } else {
              RowClasendTime  = this.timeID
        }
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:'2',
          RowClassID:this.showList.RowClassID,
          MembersID:this.MembersID,
          loginID: localStorage.getItem("LoginID"),
          RowClassTimeID:RowClasendTime,
          vipID:this.vipID,
          isST:'',
          SiteID:this.showList.SiteID,
          PreAboutCount:this.PreAboutCount,
          ListPreAboutInfo:JSON.stringify(infoList),
          MembersSubID:this.MembersSubID

        }
        var that = this
        this.ajax('addPreAboutQT.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.$message({
                    type: "success",
                    message: "预约成功",duration:2000
                  });
                  that.yuyueShow = false
                  that.getList()
                  that.getListPreAboutStu()
                  console.log('index',that.index1)
                  if(that.index1 !=''){
              
                    that.tableData = that.list[that.index1].ListRowClass[that.index2].ListRowClassSub
      
                  }
                 
              //  that.provinceList = res.data
            }

        })
      } else {
    if(this.type== 1){
        RowClasendTime  = this.showList.RowClassTimeID
        } else {
              RowClasendTime  = this.timeID
        }
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:'2',
          RowClassID:this.showList.RowClassID,
          MembersID:this.MembersID,
          loginID: localStorage.getItem("LoginID"),
          RowClassTimeID:RowClasendTime,
          vipID:this.vipID,
          isST:'',
          SiteID:this.showList.SiteID,
          PreAboutCount:this.PreAboutCount,
          ListPreAboutInfo:JSON.stringify(infoList),
          MembersSubID:this.MembersSubID

        }
        var that = this
        this.ajax('addPreAbout.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.$message({
                    type: "success",
                    message: "预约成功",duration:2000
                  });
                  that.getList()
                  that.yuyueShow = false
                  that.getListPreAboutStu()
            console.log('index',that.index1)
                if(that.index1 !=''){
              
                    that.tableData = that.list[that.index1].ListRowClass[that.index2].ListRowClassSub
                  
                  }
              //  that.provinceList = res.data
            }

        })
    
      }
      
    },
    handleDetail(items){
        this.vipName = items.Name
        this.vipPhone = items.Phone
        this.vipitems = items
        this.MembersID = items.ID
      
        this.vipShow = false
        this.pageparm = {
          currentPage: 1,
          pageSize: 10,
          total:0,
        }

        if(this.isCard == 1){
          this.cardList = [
          {
            CardName:'储蓄卡',
            ID:'-1'
          }
        ]
          this.getListMembersvip()
        } else {
          this.cardList = [
          {
            CardName:'储蓄卡',
            ID:'-1'
          },
          {
            CardName:'次卡',
            ID:'-2'
          }
        ]
        }
         this.getSubList()
    },
        getSubList(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.MembersID,
          }
          var that = this
       this.ajax('getListMembersSub.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.subList =res.data  
               that.subName = ''
               that.MembersSubID = ''    
            }
      })
      // this.ziShow = true
    },
    getListMembersvip(){

        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID: this.MembersID,
          RowClassID:this.showList.RowClassID
      }

      var that = this
      this.ajax('getContainsMemberVip.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            if(res.data.length == 0 && res.PreAboutType == 2){
                  var list = [
                    {
                      CardName:'无卡预约',
                      vipID:0
                    }
                  ]
                  that.cardList = list
                  that.vipID =  that.cardList[0].vipID  
            } else {
                that.cardList = res.data
                that.vipID = res.data[0].vipID  
            }
                
          } 

      })
   
    },showpaidui(){
      this.formInline =  {
          page: 1,
          limit:10,
          total:0,
      },
        this.getListPreAboutPD();
        
    },
    callFatherPD(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getListPreAboutPD()
    },
    getListPreAboutPD(){
      var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          RowClassID:this.showList.RowClassID
      }
    
      
        var that = this
      this.ajax('getListPreAboutPD.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              
                that.PreAboutPDList = res.data
                that.pageparm1.total = res.allcount
                that.showPreAboutPD=true;

          } 

      })
  
},handledelPreAboutPD(row){

  this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutPDID:row.ID,
        
        }
        var that = this
        this.ajax('delPreAboutPD.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000
              });
        
              that.getListPreAboutPD()
             }

        })
        })
        .catch(() => {
            ;
        });
  
},
    tochooseObj(){
     // alert(1)
      this.formInline =  {
        page: 1,
        limit:10,
        total:0,
      },
      this.selectName = ''
      this.getvipList()
      this.vipitems = ''
      this.vipName = ''
      this.MembersID = ''
      this.vipID = ''
      this.timeID=''
      if(this.isCard == 0){
        this.vipID = -1
      }
      this.cardList = []
      this.subList = []
      this.vipPhone = [],
      this.MembersSubID = ' '
      this.preAbout = false
       if(this.showList.isPreAboutInfo == 1){
         this.getPreAboutInfo()
       }
      if(this.showList.RowClassTypeqt == 1){
          this.getListRowClassTimestuQT()
      }  else {
         this.getListRowClassTimestu()
      } 
      if(this.showList.isPreAboutInfo != 1 && this.showList.RowClassTypeqt != 1 ){
          this.yuyueShow = true
      }
     
  },
getPreAboutInfo(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:'2',
          objID:this.showList.RowClassID
        }
        var that = this
        this.ajax('getListPreAboutForms.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.ListPreAboutForms = res.data
              that.ListPreAboutForms.forEach(items => {
                  items.info = ''
                  items.date = ''
                  items.time = ''
                  items.time1 = ''

              });
              console.log(that.ListPreAboutForms)
              that.timer = new Date().getTime()
              that.preAbout = true
              that.yuyueShow = true
              //  that.provinceList = res.data
            }

        })
  
},
    toVipShow(){
      this.vipShow =  true
    },
    getvipList(){
      var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          selectName:this.selectName,
      }
    
      
        var that = this
      this.ajax('getListMembersYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              
                that.vipList = res.data
                that.pageparm.total = res.allcount
          } 

      })
  
},
  getListRowClassTimestu(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          RowClassID:this.showList.RowClassID
      }

      var that = this
      this.editShow = true
      this.ajax('getListRowClassTimestu.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.timeList = res.data
                that.timeList.forEach(items=> {
                  items.time = items.startTime + '~' + items.endTime
                });
              that.yuyueShow = true
          } 

      })
  },
  getListRowClassTimestuQT(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          RowClassID:this.showList.RowClassID
      }
  
      var that = this
      this.editShow = true
      this.ajax('getListRowClassTimestuQT.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.timeList = res.data
                that.timeList.forEach(items=> {
                  items.time = items.startTime + '~' + items.endTime
                });
              that.yuyueShow = true
          } 

      })
  },
  toyue(items,index1,index2){

    this.index1 = index1
    this.index2 = index2
    this.personShow = true
    this.tableData = items.ListRowClassSub
  },
   
    toEdit(items){

      this.showList = items

          this.getListPreAboutStu()

      
      
    },

    getListPreAboutStu(){
      if(this.type == 2){
          var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          RowClassID:this.showList.RowClassID
      }
  
       var that = this
        this.ajax('getListPreAboutStu.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
               
               res.data.forEach(items => {

                  items.addTime  = items.addTime.replace(/\//g, '-')

                });
                 that.studentList = res.data
                 that.editShow = true
                 that.allcount = res.allcount

          } 

      })
      } else {
         var data = { 
              SelectStoresID:this.SelectStoresID,
              token: localStorage.getItem("token"),
              StoresID:localStorage.getItem("StoresID"),
              RowClassID:this.showList.RowClassID,
              RowClassTimeID:this.showList.RowClassTimeID
          }
  
       var that = this
        this.ajax('getListPreAboutStuTimeID.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                           res.data.forEach(items => {

                  items.addTime  = items.addTime.replace(/\//g, '-')
                  
                });
                that.studentList = res.data
                 that.editShow = true
                 that.allcount = res.allcount
                // that.editForm = res.data
                // that.editFormSure()

                // that.editShow = true
          } 

      })
      }
      
    
    },
    editFormSure(){
      this.editForm.isPreAboutInfo = Number(this.editForm.isPreAboutInfo)
      this.projectList.forEach(items => {
        
          if(items.ID == this.editForm.objID){
            this.objitems = items
            this.editForm.objID = items.ID
          }
        
      });
      this.editShow = true
      if(this.editForm.isPreAboutInfo == 1){

          this.getPreAboutInfo()

        } else {
          this.editForm.ListPreAboutForms = []
        }
 
        if(this.editForm.RowClassTypeqt=='2'){

          this.getListRowClassTime();

              } else {

          this.getListRowClassTimeQT();

        }
                   
    },

getListRowClassTime(){
 var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:2,
          RowClassID:this.editForm.ID
          // objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListRowClassTime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.listRowClassTime  = res.data

              // that.editForm.ListPreAboutForms = res.data
              //  that.provinceList = res.data

            }

        })
},
getListRowClassTimeQT(){
  var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:2,
          RowClassID:this.editForm.ID
          // objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListRowClassTimeQT.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.listRowClassTimeQT = res.data
           
              // that.editForm.ListPreAboutForms = res.data
      
              //  that.provinceList = res.data
            }

        })
},



    toqiehuan(){
      this.chooseTrue  =!this.chooseTrue
      this.getList()
    },
    getSiteList(){

       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,
      }

      var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

            that.siteList = res.data

          } 

      })
    },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },


      deleteRowClassTimeqt(row,index){

        this.listRowClassTimeQT.splice(this.listRowClassTimeQT.indexOf(row),1)

    },




    toPerson(){
        this.personShow = true
    },




        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    
      getProjectList(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:200,
            ProjectTypeID:0
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.projectList = res.data
              
          } 

      })
      },
      getPersonList(){
           var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            
         }
        var that = this
       this.ajax('getlistStaffglpb.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {

               that.personList = res.data
               
            }

      })
      },
    handleChange(val,item){
                // console.log(val)
                this.editForm.Cycle = val.join();
                // console.log(this.editForm.Cycle)
    },
    toToady(){
        var date = new Date();
        var year= date.getFullYear();
	     	var month=  date.getMonth()+1;
	    	var day= date.getDate();
        this.date = year + '-' + month + '-' + day
        this.isweek = 0
        this.getList()



    },
    toYesterDay(){
        this.$refs.nav.scrollLeft =0 
        this.$refs.externalForm.scrollLeft = 0
      if(this.type == 1){
        var date = new Date(this.date);//比如sourceDate传参“2019-03-31”
        date.setDate(date.getDate() -1);
        var year=date.getFullYear();
	     	var month=  date.getMonth()+1;
	    	var day= date.getDate();
        this.date = year+"-"+month+"-"+day;
     
      } else {
        this.date = this.timeData[0].Stime
        this.isweek = 1
      }
        this.getList()
    },
    toTomorrow(){
      this.$refs.nav.scrollLeft =0 
      this.$refs.externalForm.scrollLeft = 0
      if(this.type == 1){
            var date = new Date(this.date);//比如sourceDate传参“2019-03-31”
            date.setDate(date.getDate() + 1);
            var year= date.getFullYear();
	        	var month= date.getMonth()+1;
	    	    var day= date.getDate();
            this.date = year+"-"+month+"-"+day;
         
      } else {
        this.date = this.timeData[6].Stime
        this.isweek = 2
      }
            this.getList()
    },
    // toToady(){
    //     var date = new Date();
    //     var year = date.getFullYear(); //获取完整的年份(4位)
    //     var mounth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    //     var day =   date.getDate(); //获取当前日(1-31)
    //     this.date = year + '-' + mounth + '-' + day
    //     this.getList()
    // },
    // toYesterDay(){
    //         var date = new Date(this.date);//比如sourceDate传参“2019-03-31”
    //         date.setDate(date.getDate() -1);
    //         var year=date.getFullYear();
	  //    	var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	  //   	var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
    //        this.date = year+"-"+month+"-"+day;
    //        this.getList()
    // },
    // toTomorrow(){
    //         var date = new Date(this.date);//比如sourceDate传参“2019-03-31”
    //         date.setDate(date.getDate() + 1);
    //         var year=date.getFullYear();
	  //    	var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	  //   	var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
    //        this.date = year+"-"+month+"-"+day;
    //        this.getList()


           
    // },
    changeDate(){
      this.getList()
    },
    getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },

    changedian(){
    //   this.pageparm ={
    //     currentPage: 1,
    //     pageSize: 10,
    //     total: 0,
    //   },
      this.getPersonList()
      this.getProjectList()
      this.getSiteList()
      this.getvipList()
      this.getList()
    },
    deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
             SiteID:row.ID,
        
        }
        var that = this
        this.ajax('delSite.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },


    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑' + this.WZPBName
       
           
    
          } else {

              this.title = this.WZPBName
              this.objitems = {}
              this.checkedCycles = []
              this.LoginIDs = []
              this.ListPreAboutForms = []
              this.editForm = {
                shour:'',
                sminute:'',
                RowClassType:1,
                SiteName:'',
                isPreAboutInfo:0,
                ListPreAboutForms:[],
                ListRowClassTime:" ",
                LoginIDs:'',
                Timelength:'',
                objID:'',
                RowClassTypeqt:'1',
                xhAmount:0,
                payPrice:0,
                iscx:'1',
                isck:'0',
                xhnumber:0,
                Timelengthqt:30,
                integral:0,
                IsPay:'0',
                PreAboutType:1,
          }
              
      }
          this.editFormVisible = true
    },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },
    search1(){
      this.formInline =  {
          page: 1,
          limit:10,
        
      },
      this.getvipList()
    },
    search() {

      this.getList()
      // this.getdata(this.formInline)
    },
    getDayList(){

      var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            SKtime:this.date,
            objID:this.objID,
            Site:this.Site,
            LoginID:this.LoginID,
            RowType:this.RowType
      }

        var that = this
    if(this.chooseTrue == true){
       this.ajax('getListRowClassYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.tableLoading = false
                that.timeData = res.data
                that.list = res.terList

          } 

      })
    } else {

      this.ajax('getListRowClassProjectYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.timeData = res.data
                that.list = res.ProjectList  
          } 

      })
    }
     this.cd = false
     var date = new Date();
        var year=date.getFullYear();
	     	var month=  date.getMonth()+1;
	    	var day=  date.getDate();
      var   today =  year + '-' + month + '-' + day
      if(this.date == today ){
        var myDate = new Date();
          if(myDate.getHours() <10){
        var hour = '0' + myDate.getHours() 
         } else {
        var hour =  myDate.getHours() 
        }
        if(myDate.getMinutes()<10){
        var minute = '0' + myDate.getMinutes()
        } else {
        var minute =  myDate.getMinutes()
        }
        var time = hour + ':' + minute
         
      //  console.log(time)
      for( var i = 0;i<this.timeData.length;i++){
          if(time < this.timeData[i].startTime)
            {
              var t = i 
              break
            }
      }
      this.$nextTick(()=>{
    
    
      this.$refs.list1.forEach((item,index)=>{
        if(index  == t){

            item.scrollIntoView({ behavior: "auto",block: "start",inline:'center'})
            this.exterHandleScroll()
        }

     
      })
    })
                
    }
          this.$loading().close()
  },
    getList(){
      // this.$loading({
      //         lock: true,
      //         text: '加载中...',
      //         spinner: 'el-icon-loading',
      //         background: 'rgba(0, 0, 0, 0.7)'
      // });
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      // console.log(loading)
      console.log(this.type)
      var date = new Date(this.date)
      var day = date.getDay()

    
      this.day = day
  if(this.type == 1){
    this.getDayList()
    } else {
      this.getWeeks()
    }
  },
getWeeks(){
    var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            SKtime:this.date,
            objID:this.objID,
            Site:this.Site,
            LoginID:this.LoginID,
            isweek:this.isweek,
            RowType:this.RowType,

      }
      //  const loading = this.$loading({
      //     lock: true,
      //     text: '加载中...',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      //   });
        var that = this
    if(this.chooseTrue == true){
       this.ajax('getListRowClassWeeksYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.timeData = res.data
                that.list = res.terList
                //  loading.close();

          } 

      })
    } else {
      this.ajax('getListRowClassProjectWeeksYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.timeData = res.data
                that.list = res.ProjectList
              //  loading.close();
          } 

      })
    }
          this.$loading().close()
},
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getvipList()
    },
    // 搜索事件

    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
                
            if(this.title == this.WZPBName){
                if(this.editForm.Timelength == ''){
                   this.$message({ type: "error", message: "请输入项目时长" ,duration:1000});
                  return;
             }
              if(this.editForm.RowClassTypeqt=='1' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTimeQT.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
              if(this.editForm.RowClassTypeqt=='2' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTime.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
                if(this.editForm.IsPay==1){
                    if(this.editForm.payPrice == 0){
                          this.$message({ type: "error", message: "请输入支付金额" ,duration:1000});
                          return;
                    }
                }
              if(this.editForm.isck==1){
//                     if(this.editForm.xhnumber == 0){
//                           this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
//                           return;
//                     }
                }
              if(this.editForm.iscx == 1){
//                     if(this.editForm.xhAmount == 0){
//                           this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
//                           return;
//                     }
                }
                  if(this.editForm.iscx == 0){
                        data.xhAmount = 0 
                  }
                  if(this.editForm.isck == 0){
                        data.xhnumber = 0 
                  }
                  var LoginIDs =''
                  this.LoginIDs.forEach(items => {
                        LoginIDs = LoginIDs +items.ID + ','
                  })
                  LoginIDs = LoginIDs.substring(0, LoginIDs.lastIndexOf(','));
                  data.LoginIDs = LoginIDs
                if(data.LoginIDs =='')
                data.LoginIDs = 0
                 data.ListPreAboutForms = JSON.stringify(data.ListPreAboutForms)
              if(this.editForm.RowClassTypeqt == 1){
                 let list = JSON.stringify(this.listRowClassTimeQT)
                data.ListRowClassTime = list 
                //  this.editForm.Timelengthqt =levels;
                  this.ajax('addRowClassQT.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
              
              } else {
                    let list = JSON.stringify(this.listRowClassTime)
                      data.ListRowClassTime = list
                       this.ajax('addRowClass.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
                
              }
                

            }else {
                data.SiteID =  this.editForm.ID
                 this.ajax('editSite.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },
    sub(){
      var data = this.editForm
          data.token=localStorage.getItem("token")
          data.StoresID=localStorage.getItem("StoresID")
          data.SelectStoresID  = this.SelectStoresID
          data.RowClassID = data.ID
          data.ListPreAboutForms = JSON.stringify(data.ListPreAboutForms)
          // console.log(ListPreAboutForms)
          var that = this
//                  if(this.editForm.Timelength == ''){
//                    this.$message({ type: "error", message: "请输入项目时长" ,duration:1000});
//                   return;
//              }
              if(this.editForm.RowClassTypeqt=='1' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTimeQT.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
              if(this.editForm.RowClassTypeqt=='2' && this.editForm.RowClassType=='1'){
                    if(this.listRowClassTime.length == 0){
                          this.$message({ type: "error", message: "请添加预约时间表" ,duration:1000});
                          return;
                    }
                }
                if(this.editForm.IsPay==1){
                    if(this.editForm.payPrice == 0){
                          this.$message({ type: "error", message: "请输入支付金额" ,duration:1000});
                          return;
                    }
                }
//               if(this.editForm.isck==1){
// //                     if(this.editForm.xhnumber == 0){
// //                           this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
// //                           return;
// //                     }
//                 }
//               if(this.editForm.iscx == 1){
// //                     if(this.editForm.xhAmount == 0){
// //                           this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
// //                           return;
// //                     }
//                 }
                  if(this.editForm.iscx == 0){
                        data.xhAmount = 0 
                  }
                          if(this.editForm.isck == 0){
                        data.xhnumber = 0 
                  }
            if(this.editForm.RowClassTypeqt == 1){
                 let list = JSON.stringify(this.listRowClassTimeQT)
                data.ListRowClassTime = list 
                //  this.editForm.Timelengthqt =levels;
                  this.ajax('editRowClassQT.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000
                        });
                        that.editShow = false
                        that.getList()
                     }

                })
              
              } else {
                    let list = JSON.stringify(this.listRowClassTime)
                      data.ListRowClassTime = list
                       this.ajax('editRowClass.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000
                        });
                        that.editShow = false
                        that.getList()
                     }

                })
                
              }

    },
    closeDialog1(){
        this.objShow = false
        this.preShow = false
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
    
        
      this.passShow = false
      this.chongShow = false
      this.editFormVisible = false
    }
  }
}
</script>

<style>

.bcss{
  position: absolute;
  font-weight:600;
  font-size:16px;
  z-index:99;
  background-color:white
}

::-webkit-scrollbar  
{  
    z-index: 99999 !important;
    height: 6px;  
    width: 6px;
    /* background-color: #F5F5F5;   */
}
::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    background: rgba(0,0,0,.25) !important;
}
</style>
<style scoped>
.yueren{
  background: #67C23A;
  color:white;
  font-size: 15px;
  padding: 2px 15px 2px 15px;
  border-radius: 50px;
}
.topTime{
  position: absolute;
  overflow: hidden;
}
  .count{
    background-color: rgb(250, 67, 67);
    width: 20px;
    height: 20px;
    color: white;
    border-radius: 100%;
    font-size:10px;
  }
.da{
  width: 99%;
  height:calc(75vh - 100px);
  overflow: hidden;
 
  /* margin-top:10px; */
}
.isFixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
 }
.leftMain{
  width: 100%;
  height: 100%;
  /* padding-bottom: -8px; */
  overflow: auto;
  overflow-x:auto
}
.postMain{
  position: absolute;
  background-color: white;
  overflow:hidden;
  height:calc(100% - 6px);
   /* overflow-y: auto */
}
.hov:hover{

  background-color: #c6def1;
}
.quanbu1{
   font-size: 10px;
     font-size: 10px;
  color: #bebebe;
}
.quanbu{
  position:absolute;
  bottom: 0;
  left: 0;
  font-size: 13px;
  color: #40a9ff;

}
.boxMain{
  position: relative;
}
  .qiu{
    width: 15px;
    height: 15px;
    margin-left: 5px;
    border-radius: 100%;
     
  }
.f-mt-10 {
    margin-top: 10px;
}
.itemWrap___33SF3 {
    text-align: left;
    margin-bottom: 8px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
 }
.itemWrap___33SF31 {
    text-align: left;
    margin-bottom: 8px;
    margin-left: 10px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
     width: 60px;
}
.itemWrap___33SF31 {
    text-align: left;
    margin-bottom: 8px;
    margin-left: 10px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
     width: 60px;
}
.g-items-wrap {
    padding: 10px 15px;
    border: 1px dashed #40a9ff;
}
.f-mt-10 {
    margin-top: 10px;
}
.dialogMain{
    overflow: auto;
}
.dilag-fix{
    position:absolute;
    right: 0;
    bottom: 0;
    margin-bottom: 10px;

}
.mian{
  height: 300px;
    overflow: auto;
  overflow-x: hidden
 
}
.hen{
  width: 95%;
  border: 1px dashed #65a8ff;
  margin-left: 2.5%;
  padding-top:10px;
  padding-bottom: 10px;
}
.mainTitle{
  border-radius: 5px;
  width: 95%;
  height: 95%;
  background-color: white;
}
.left{
  background-color: #e0e0e0;
}
.jingp{
  width:50px;

  margin-left: 10px;
  font-size: 13px;
}
.kuai{
  margin-left: 10px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
}
.topTime{
  position: absolute;
  overflow: hidden;
}
.bgColor{
  width:215px;
  height:30px;
  border:1px solid #808080;
  margin-top:5px;
  border-radius: 4px;
}
.maxw{

     display: flex;   

     /* -ms-flex-wrap: wrap;
     flex-wrap: wrap;
     -webkit-box-pack: start;
     -ms-flex-pack: start;
     justify-content: flex-start; */
  
}

.main{
    /* overflow-x: auto; */
    border:1px solid #e2e2e2;
    overflow:hidden;
    height: 99%;
    /* margin-top:20px; */
    width: 100%;
  
    position: relative;
  
}
.box{
    min-width:200px;
    width:20px;
    height:50px;
    border-bottom:6px solid #f5f4f4;
    border-right:1px solid #e2e2e2;
    font-size: 14px;

}
.box1{
    min-width:200px;
    width:20px;
    background: white;
    height:120px;
    font-size: 14px;
    border-right:1px solid #e2e2e2;
    border-bottom:6px solid #f5f4f4;
}
.top{
    border-top:1px solid #e2e2e2;
    /* padding-top:20px; */
    margin-top: 15px;
}

.userRole {
  width: 100%;
}
.qie{
  color:#65a8ff;
  font-weight: 500;
  font-size: 16px;
  
}
</style>



// WEBPACK FOOTER //
// src/views/appointment/appointment.vue